module.exports = __webpack_public_path__ + "img/watching.9d49a640.svg";